import React, { Component } from 'react';
import './Search.css';

export class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        }
    }
    render() {
        return (
            <div className="search-title-bar">
                <div id="search-container">
                    <div className="center-content">
                        <form
                            role="search"
                            alt="Search Bar"
                            className="search-form"
                            autoComplete="off"
                            onSubmit={(e) => this.doSearch(e)}>

                            <div className="search-input-wrapper">
                                <input
                                    onChange={(e) => this.searchValueChanged(e)}
                                    className="search-input search-input-highlighted"
                                    type="text"
                                    id="search-terms"
                                    placeholder="Search for keywords, languages, etc."
                                    maxLength="250"
                                    aria-label="Search"
                                />
                                <button
                                    type="button"
                                    id="search-clear"
                                    className="btn-unstyle search-clear-icon"
                                    aria-label="Clear search field">
                                </button>
                            </div>

                            <button
                                type="button"
                                id="search-clear"
                                className="btn-search"
                                aria-label="Clear search field"
                                onClick={(e) => this.doSearch(e)}>
                                <div className="search-icon"></div>
                            </button>

                            <div
                                className="popover-menu popover-search-menu showing-header hidden"
                                id="search-autocomplete-popover">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    searchValueChanged(e) {
        this.setState({
            searchText: e.target.value
        });
    }
    doSearch(e) {
        e.preventDefault()
        this.props.onChange(this.state.searchText);
    }
}



// WEBPACK FOOTER //
// ./src/components/Search.js